export default {
  title: {
    messages: "Messages",
    messagesManagement: "Messages Management"
  },
  showMoreButton: "Show More Messages",
  noMassages: "You have no messages",
  readAllButton: "Mark All as Read"
};
